import { ThemesColorsEnum } from '../interfaces/themes-colors.enum';
import { CommunicationService } from './communication.service';
import AngularJsThemes from '../themes';
import { convertHexPaletteToRgb } from '../helpers/theme-helper';
var ThemeManagement = /** @class */ (function () {
    function ThemeManagement() {
        this.currentThemeName = localStorage.getItem('theme') || ThemeManagement.defaultTheme;
        /*
        Adiciona o tema da versão 12 por padrão
        para evitar lentidão no carregamento das cores da sidenav e toolbar
      */
        this.addThemeVersion('12');
        if (localStorage.getItem('theme') == null) {
            localStorage.setItem('theme', ThemeManagement.defaultTheme);
        }
        this.currentThemeName = localStorage.getItem('theme');
    }
    ThemeManagement.singleton = function () {
        if (!ThemeManagement.themeManagement) {
            ThemeManagement.themeManagement = new ThemeManagement();
        }
        return ThemeManagement.themeManagement;
    };
    Object.defineProperty(ThemeManagement.prototype, "currentThemeNameValue", {
        get: function () {
            return this.currentThemeName;
        },
        enumerable: false,
        configurable: true
    });
    ThemeManagement.prototype.addLinkInDocument = function (href, version) {
        if (this.isLinkTagAlreadyInDOM(version))
            return;
        var linkTag = document.createElement('link');
        linkTag.setAttribute('rel', 'stylesheet');
        linkTag.setAttribute('href', href);
        linkTag.setAttribute('type', 'text/css');
        linkTag.setAttribute('data-theme-version', version);
        document.head.appendChild(linkTag);
    };
    ThemeManagement.prototype.isLinkTagAlreadyInDOM = function (themeVersion) {
        var element = document.querySelector("[data-theme-version=\"".concat(themeVersion, "\"]"));
        return !!element;
    };
    ThemeManagement.prototype.selectAngularProjectsVersions = function () {
        var angularProjectsVersionsArray = Array.from(document.querySelectorAll('[ng-version]'));
        return angularProjectsVersionsArray.map(function (element) {
            return element.getAttribute('ng-version');
        });
    };
    ThemeManagement.prototype.initListener = function () {
        var _this = this;
        window.addEventListener('single-spa:app-change', function () {
            _this.addThemeInDocument();
        });
    };
    ThemeManagement.prototype.addThemeInDocument = function () {
        var _this = this;
        var projectVersions = this.selectAngularProjectsVersions();
        projectVersions.forEach(function (projectVersion) {
            if (projectVersion.startsWith('7')) {
                _this.addThemeVersion('7');
            }
            else if (projectVersion.startsWith('8')) {
                _this.addThemeVersion('8');
            }
            else if (projectVersion.startsWith('9')) {
                _this.addThemeVersion('9');
            }
            else if (projectVersion.startsWith('12')) {
                _this.addThemeVersion('12');
            }
        });
        this.addThemeVersion('default');
    };
    ThemeManagement.prototype.removeOldTheme = function () {
        var linkElements = document.querySelectorAll('[data-theme-version]');
        linkElements.forEach(function (element) { return element.remove(); });
    };
    ThemeManagement.prototype.changeTheme = function (newThemeName) {
        this.currentThemeName = String(newThemeName);
        this.removeOldTheme();
        localStorage.setItem('theme', this.currentThemeName);
        this.addThemeInDocument();
        CommunicationService.singleton().emitCustomEvent('cosmosChangeTheme', { url: this.getTheme(this.currentThemeName, 'default') });
    };
    ThemeManagement.prototype.getTheme = function (color, versionNumber) {
        // eslint-disable-next-line no-undef, camelcase
        var themePath = "".concat(__webpack_public_path__, "public/themes/version-").concat(versionNumber, "/theme-").concat(color, ".css");
        return themePath;
    };
    ThemeManagement.prototype.getCurrentThemeUrl = function () {
        // eslint-disable-next-line no-undef, camelcase
        var themePath = "".concat(__webpack_public_path__, "public/themes/version-default/theme-").concat(this.currentThemeName, ".css");
        return themePath;
    };
    ThemeManagement.prototype.getCurrentThemePalleteForAngularjs = function () {
        var theme = this.currentThemeName.toString();
        var palletes = AngularJsThemes['Theme' + theme.charAt(0).toUpperCase() + theme.slice(1)];
        if (palletes) {
            Object.keys(palletes).forEach(function (key) {
                palletes[key] = convertHexPaletteToRgb(palletes[key]);
            });
            return palletes;
        }
        else {
            return null;
        }
    };
    ThemeManagement.prototype.addThemeVersion = function (version) {
        var themeVersion = this.getTheme(this.currentThemeName, version);
        this.addLinkInDocument(themeVersion, version);
    };
    ThemeManagement.defaultTheme = String(ThemesColorsEnum.THEME_03);
    return ThemeManagement;
}());
export { ThemeManagement };
